interface PeriodToggleProps {
  isAnnual: boolean;
  onToggle: (isAnnual: boolean) => void;
}

export default function PeriodToggle({ isAnnual, onToggle }: PeriodToggleProps) {
  return (
    <div className="mb-6 flex items-center justify-center">
      <div
        role="tablist"
        aria-label="Période d'affichage"
        className="inline-flex items-center p-1 bg-gray-100 rounded-full"
      >
        <button
          role="tab"
          aria-selected={!isAnnual}
          onClick={() => onToggle(false)}
          className={`px-4 py-1.5 text-sm font-medium rounded-full transition-colors ${
            !isAnnual
              ? 'bg-white text-emerald-700 shadow-sm'
              : 'text-gray-600 hover:text-gray-900'
          }`}
        >
          Mensuel
        </button>
        <button
          role="tab"
          aria-selected={isAnnual}
          onClick={() => onToggle(true)}
          className={`px-4 py-1.5 text-sm font-medium rounded-full transition-colors ${
            isAnnual
              ? 'bg-white text-emerald-700 shadow-sm'
              : 'text-gray-600 hover:text-gray-900'
          }`}
        >
          Annuel
        </button>
      </div>
    </div>
  );
}
